module.exports = __webpack_public_path__ + "static/media/weight.914a07fa.svg";